module.exports = __webpack_public_path__ + "img/15m.9220a1fe.png";